const key = 'platformplatform'
const headerBasic = 'platform:a050c7db77eb4b1bb8b2b'
const commonName = 'auth-server/auth-api/v2'
const commonNameV2 = 'auth-server/auth-api/v2'
// const key = 'driver1234567890'
// const headerBasic = 'driver:driver'
// const commonName = 'monitor'

// const key = 'vgs1234567890vgs'
// const headerBasic = 'vgs:vgs'
// const commonName = 'match'

// const key = 'platformplatform'
// const headerBasic = 'platform:a050c7db77eb4b1bb8b2b'
// const commonName = '/stock'

// const driverName = '/driver'
// const matchName = '/match'
// const stockName = 'stock'
// const vehMonitor = '/monitor'
const payName = 'pay-server/pay'
const contractName = 'contract-server/contract'
const orderName = 'order-server/order'
const videoName = 'video-monitor-server/video'
const cutomerName = 'soc-customer-server/customer'
const stockName = 'soc-stock-server/stock'
const matchName = '/vgs-match-server/match'
const driverName = '/vgs-driver-server2/driver2'
const statisticsName = '/vgs-statistics-server/statistics'
const signature = 'common-signature-server/common-signature'
const wmsAccessName = 'wms-access-server/wmsAccess'
const wmsStockName = 'wms-stock-server/wmsStock'
const dataCenterName = 'data-center-server/dataCenter'
const zhbPanel = '/zw56-zhb-panel-server/zhb_panel'
const vehMonitor = 'common-signature-server/common-signature' // vgs-monitor-server/monitor改为common-signature-server
const smpName = '/zw56-smp-server/smp'
const crm = '/crm-server/crm'
const payServer = '/pay-server/pay'
const zhbEss = '/zw56-zhb-ess-server/zhbess'
const mapTime = {
  commonTime: 1000 * 5,
  waybillTime: 1000 * 5
}

const spuName = '/zw56-spu-server/spu' // spu服务换成smp服务
const driverNameT = '/vgs-driver-server2/driver2'
const crmServer = 'crm-server/crm/'
const wmsCenter = 'wms-center-server/wmsCenter'
const shipping = 'zw56-ship-server/ship'
const ZXpingzheng = 'https://corp.bank.ecitic.com/cotb/m000A0101.html?'// 电子回单批量
const baseUrl = 'https://any.zw56.com'
// 中厚板厂内用车
const zhb_vas = '/zw56-zhb-vas-server/zhb_vas'
const crmServer3 = '/crm-server3/crm3'
const tms = 'tms-server/tms'
const vehicleAccount = 'base-account-server/baseAccount'
const tmsPlus = 'tmsPlus-server/tmsPlus'
const businessCodeYS = '00001K'// 运输运营业务code
const lj = 'lj-server/lj' // 乐居
export default {
  key,
  headerBasic,
  commonName,
  videoName,
  cutomerName,
  stockName,
  matchName,
  driverName,
  statisticsName,
  signature,
  wmsAccessName,
  wmsStockName,
  dataCenterName,
  zhbPanel,
  vehMonitor,
  mapTime,
  spuName,
  smpName,
  contractName,
  orderName,
  driverNameT,
  payName,
  crm,
  crmServer,
  payServer,
  wmsCenter,
  shipping,
  zhbEss,
  ZXpingzheng,
  baseUrl,
  zhb_vas,
  crmServer3,
  commonNameV2,
  tms,
  vehicleAccount,
  tmsPlus,
  businessCodeYS,
  lj
}
